//
//

import { mapActions, mapGetters } from "vuex";
import columns from "./columns.js";

export default {
    data() {
        return {
            paginationControl: { rowsPerPage: 15, page: 1 },
            columns,
            filter: ""
        };
    },
    computed: {
        ...mapGetters("admin", [
            "componentList",
            "loadingComponents"
        ])
    },
    methods: {
        ...mapActions("admin", [
            "getComponentsList",
            "removeComponent",
            "installComponent",
            "updatecomponent",
            "syncComponents"
        ]),
        showList() {
            console.log(this.componentList);
        },
        remove(component) {
            this.removeComponent(component);
        },
        install(component) {
            this.installComponent(component);
        },
        update(component) {
            this.updatecomponent(component);
        },
        sync() {
            this.syncComponents();
        }
    },
    mounted() {
        this.getComponentsList();
        // this.columns.map(column => column.label = column.label ? this.$t(column.label) : '');
    }
};
